import { Route } from "react-router";
import { all_routes } from "./all_routes";

// Dashboard
import DashboardAdminBussiness from "../../../backendComponents/admin/dashboardBussiness/dashboardAdminBussiness";
import DashboardWebsiteBussiness from "../../../backendComponents/website/dashboardBussiness/dashboardWebsiteBussiness";

// Support
// import ContactRequestMessage from "../../../backendComponents/admin/support/contactRequestMessage";
// import FAQ from "../../../backendComponents/admin/support/faq";
// import Ticket from "../../../backendComponents/admin/support/ticket";

// Vendors
import Source from "../../../backendComponents/admin/vendor/source/source";
import Supplier from "../../../backendComponents/admin/vendor/supplier/supplier";
import Courier from "../../../backendComponents/admin/vendor/courier/courier";

// Configuration
import Principal from "../../../backendComponents/admin/configuration/principal/principal";
import Reason from "../../../backendComponents/admin/configuration/reason/reason";
import AddUpdateQuotationFormat from "../../../backendComponents/admin/configuration/quotrationFormat/addUpdateQuotrationFormat";
import AddUpdateNotification from "../../../backendComponents/admin/configuration/notification/addUpdateNotification";

// Product
import Product from "../../../backendComponents/admin/product/addUpdateProduct";
import Parameter from "../../../backendComponents/admin/product/addUpdateParameter";
import UPS from "../../../backendComponents/admin/product/addUpdateUsp";
import Brand from "../../../backendComponents/admin/product/addUpdateBrand";
import Category from "../../../backendComponents/admin/product/addUpdateCategory";

// Client
import Owner from "../../../backendComponents/admin/clientUsers/owner";
import Customer from "../../../backendComponents/admin/clientUsers/customer";
import User from "../../../backendComponents/admin/clientUsers/user";
import RoleAccess from "../../../backendComponents/admin/clientUsers/roleAccess";

// Sales
import Invoice from "../../../backendComponents/admin/sales/invoice/invoice";
import QuotationReport from "../../../backendComponents/admin/sales/quotation/quotationReport";
import Order from "../../../backendComponents/admin/sales/order/order";
import PartialOrder from "../../../backendComponents/admin/sales/order/partialOrder";
import OrderReport from "../../../backendComponents/admin/sales/order/orderReport";
import OrderSummary from "../../../backendComponents/admin/summary/orderSummary";
import QuotationSummary from "../../../backendComponents/admin/summary/quotationSummary";
import SaleReport from "../../../backendComponents/admin/summary/expanses/SaleReport/saleReport";
import ExpensesSummary from "../../../backendComponents/admin/summary/expanses/expanses";
import Login from "../../../authentication/backendModule/admin/login";
import Error404 from "../../../authentication/backendModule/admin/404";
import Quotation from "../../../backendComponents/admin/sales/quotation/quotation";
import Manageusers from "../../../backendComponents/admin/clientUsers/profileDetails";
import PerformanceReport from "../../../backendComponents/admin/summary/expanses/SaleReport/performanceReport";
import NotificationPush from "../../../backendComponents/admin/configuration/notification/notificationPush";

const route = all_routes;

export const publicRoutes = [
  {
    path: route.login,
    element: <Login />,
    route: Route,
    title: "Login",
  },
];

export const authRoutes = [
  {
    path: route.dashboard,
    element: <DashboardAdminBussiness />,
    route: Route,
    title: "Dashboard",
  },
  {
    path: route.dashboardAdmin,
    element: <DashboardAdminBussiness />,
    route: Route,
    title: "Dashboard",
  },

  // {
  //   path: route.dashboardWebsite,
  //   element: <DashboardWebsiteBussiness />,
  //   route: Route,
  //   title: "Website Dashboard",
  // },

  // {
  //   path: route.contactRequest,
  //   element: <ContactRequestMessage />,
  //   route: Route,
  //   title: "Contact Info",
  // },

  // {
  //   path: route.faq,
  //   element: <FAQ />,
  //   route: Route,
  //   title: "FAQ",
  // },

  // {
  //   path: route.ticket,
  //   element: <Ticket />,
  //   route: Route,
  //   title: "Ticket",
  // },

  {
    path: route.source,
    element: <Source />,
    route: Route,
    title: "Source",
  },

  {
    path: route.supplier,
    element: <Supplier />,
    route: Route,
    title: "Supplier Info",
  },

  {
    path: route.quotationFormat,
    element: <AddUpdateQuotationFormat />,
    route: Route,
    title: "Quotation Format",
  },

  {
    path: route.principal,
    element: <Principal />,
    route: Route,
    title: "Principal",
  },

  {
    path: route.reason,
    element: <Reason />,
    route: Route,
    title: "Reason",
  },

  // {
  //   path: route.notifications,
  //   element: <AddUpdateNotification />,
  //   route: Route,
  //   title: "Notification",
  // },
  {
    path: route.product,
    element: <Product />,
    route: Route,
    title: "Product",
  },

  {
    path: route.parameter,
    element: <Parameter />,
    route: Route,
    title: "Parameter",
  },

  {
    path: route.usp,
    element: <UPS />,
    route: Route,
    title: "UPS",
  },

  {
    path: route.brand,
    element: <Brand />,
    route: Route,
    title: "Brand",
  },

  {
    path: route.category,
    element: <Category />,
    route: Route,
    title: "Category",
  },

  {
    path: route.owner,
    element: <Owner />,
    route: Route,
    title: "Owner",
  },

  {
    path: route.customer,
    element: <Customer />,
    route: Route,
    title: "Customer",
  },

  {
    path: route.user,
    element: <User />,
    route: Route,
    title: "User",
  },

  {
    path: route.roleAcess,
    element: <RoleAccess />,
    route: Route,
    title: "Role & Permission Access",
  },

  {
    path: route.invoice,
    element: <Invoice />,
    route: Route,
    title: "Invoice",
  },

  {
    path: route.quotation,
    element: <Quotation />,
    route: Route,
    title: "Quotation",
  },

  {
    path: route.quotationReport,
    element: <QuotationReport />,
    route: Route,
    title: "QuotationReport",
  },

  {
    path: route.order,
    element: <Order />,
    route: Route,
    title: "Order",
  },

  {
    path: route.partialOrder,
    element: <PartialOrder />,
    route: Route,
    title: "Partial Order",
  },

  {
    path: route.orderReport,
    element: <OrderReport />,
    route: Route,
    title: "Order Report",
  },
  {
    path: route.courier,
    element: <Courier />,
    route: Route,
    title: "Order Report",
  },

  {
    path: route.orderSummary,
    element: <OrderSummary />,
    route: Route,
    title: "Order Report",
  },
  {
    path: route.quotationSummary,
    element: <QuotationSummary />,
    route: Route,
    title: "Order Report",
  },
  {
    path: route.performanceReport,
    element: <PerformanceReport />,
    route: Route,
    title: "Order Report",
  },
  {
    path: route.saleReport,
    element: <SaleReport />,
    route: Route,
    title: "Order Report",
  },
  {
    path: route.expences,
    element: <ExpensesSummary />,
    route: Route,
    title: "Order Report",
  },
  {
    path: route.pageNotFound,
    element: <Error404 />,
    route: Route,
    title: "Page Not Found",
  },

  {
    path: route.profileDetails,
    element: <Manageusers />,
    route: Route,
    title: "Profile",
  },

  {
    path: route.notifications,
    element: <NotificationPush />,
    route: Route,
    title: "Profile",
  },
];
